import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import FreelancerLayout from "../../layouts/FreelancerLayout";
import { fetchfreelancerProfile } from "../../redux/features/find-a-job/actions/authAction";
import Loader from "../../components/loader";
import { getProfile } from "../../utils/pip";

const Growth = () => {
    const { subLoading } = useSelector((state) => state.freelancer.auth);

      if (subLoading) {
    return <Loader />;
  }
  return (
    <div>
      <FreelancerLayout />
      <div className="ct_px_40 my-5">
        <div className="container-fluid">
          <div className="row gx-5">
            <div className="col-xxl-3 col-xl-4 col-lg-4 mb-4">
              <div>
                <div className="ct_outline_bg ct_p_20 ct_box_shadow_card_1 ct_border_radius_10">
                  <div className="d-flex align-items-center justify-content-between gap-3 ct_mb_10">
                    <div>
                      <img
                        src="../assets/img/Avatar_11_big.png"
                        className="ct_img_56"
                      />
                    </div>
                    <div>
                      <svg
                        width="30"
                        height="30"
                        viewBox="0 0 30 30"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9.75 20.25V17.7708L17.45 10.0854C17.5667 9.97847 17.6956 9.89583 17.8368 9.8375C17.9779 9.77917 18.1261 9.75 18.2812 9.75C18.4364 9.75 18.5871 9.77917 18.7333 9.8375C18.8796 9.89583 19.0059 9.98333 19.1125 10.1L19.9146 10.9167C20.0312 11.0236 20.1164 11.15 20.1701 11.2958C20.2238 11.4417 20.2504 11.5875 20.25 11.7333C20.25 11.8889 20.2234 12.0373 20.1701 12.1784C20.1168 12.3196 20.0316 12.4483 19.9146 12.5646L12.2292 20.25H9.75ZM18.2667 12.55L19.0833 11.7333L18.2667 10.9167L17.45 11.7333L18.2667 12.55Z"
                          fill="#535862"
                        />
                      </svg>
                    </div>
                  </div>
                  <h6 className="ct_fs_16 ct_darkblue_text mb-1">Alex Brown</h6>
                  <p className="ct_fs_14">Los Angeles, CA 90045</p>
                  <ul className="ct_mb_16">
                    <li className="d-flex align-items-center gap-2 justify-content-between">
                      <p className="mb-0 ct_fs_14 ct_grey_text ct_white_nowrap">
                        Most Recent Job
                      </p>
                      <p className="mb-0 ct_fs_14 ct_grey_text text-truncate ct_darkblue_text">
                        CodeNest
                      </p>
                    </li>
                    <li className="d-flex align-items-center gap-2 justify-content-between ct_mt_16">
                      <p className="mb-0 ct_fs_14 ct_grey_text ct_white_nowrap">
                        Last Qualification
                      </p>
                      <p className="mb-0 ct_fs_14 ct_grey_text text-truncate ct_darkblue_text">
                        UI/UX Designer
                      </p>
                    </li>
                    <li className="d-flex align-items-center gap-2 justify-content-between ct_mt_16">
                      <p className="mb-0 ct_fs_14 ct_grey_text ct_white_nowrap">
                        Work Experience
                      </p>
                      <p className="mb-0 ct_fs_14 ct_grey_text text-truncate ct_darkblue_text">
                        5.5 Years
                      </p>
                    </li>
                  </ul>
                  <div className="d-flex align-items-center gap-2">
                    <img src="../assets/img/grey_mail_icon.svg" />
                    <p className="mb-0 ct_fs_14 ct_grey_text">
                      alexbrown@gmail.com
                    </p>
                  </div>
                  <div className="d-flex align-items-center ct_mt_10 gap-2">
                    <img src="../assets/img/grey_phon_icon.svg" />
                    <p className="mb-0 ct_fs_14 ct_grey_text">1234567891</p>
                  </div>

                  <div className="ct_mt_27">
                    <button className="ct_yellow_btn ct_h_37 w-100 ct_fs_14">
                      Edit Profile
                    </button>
                  </div>
                </div>

                <div className="ct_mt_40">
                  <ul>
                    <li>
                      <div className="ct_outline_bg ct_box_shadow_card_1 ct_p_10 ct_border_radius_10">
                        <p className="mb-0 ct_fs_16 ct_darkblue_text">
                          Coaching
                        </p>
                      </div>
                    </li>
                    <li className="mt-4">
                      <div
                        className="ct_outline_bg ct_box_shadow_card_1 ct_p_10 ct_border_radius_10"
                        style={{ backgroundColor: "#8ECAE6" }}
                      >
                        <p className="mb-0 ct_fs_16 ct_darkblue_text">Ebook</p>
                      </div>
                    </li>
                    <li className="mt-4">
                      <div className="ct_outline_bg ct_box_shadow_card_1 ct_p_10 ct_border_radius_10">
                        <p className="mb-0 ct_fs_16 ct_darkblue_text">
                          Workshop
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>

                <div className="ct_mt_40 ct_outline_bg ct_box_shadow_card_1 ct_border_radius_10 ct_p_20 text-center">
                  <h5 className="ct_fs_16 ct_darkblue_text ct_mb_16">
                    Don’t Miss Any Update
                  </h5>
                  <p
                    className="ct_fs_14 ct_grey_text mb-0 mx-auto"
                    style={{ maxWidth: "253px" }}
                  >
                    Be the first to know about upcoming events, remote work,
                    courses, and everything about hiring and working better
                  </p>
                  <div className="mt-4">
                    <div className="form-group">
                      <input
                        type="email"
                        className="form-control ct_input  ct_h_37"
                        placeholder="Enter Email"
                      />
                    </div>
                    <div className="ct_mt_20">
                      <button className="ct_yellow_btn ct_darkblue_btn ct_fs_14 w-100 ct_h_37">
                        Subscribe
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xxl-8 col-xl-7 col-lg-7 mb-4">
              <div className="ct_outline_bg ct_p_40 ct_box_shadow_card_1 ct_border_radius_10 h-100">
                <ul className="d-flex align-items-center gap-4">
                  <li className="ct_grey_text ct_darkblue_text">Coaching</li>
                  <li className="ct_grey_text">Ebook</li>
                  <li className="ct_grey_text">Workshop</li>
                </ul>

                <div class="ct_session_card pt-5">
                  <div class="ct_session_header ct_flex_col_575">
                    <div>
                      <h6>
                        Your Total Coach Sessions <span>(12)</span>
                      </h6>
                      <p className="ct_mt_16">
                        Total used: <strong>5</strong>
                      </p>
                    </div>

                    <div class="ct_toggle_btns">
                      <button class="active ct_white_nowrap">Current</button>
                      <button className="ct_white_nowrap">Future</button>
                    </div>
                  </div>

                  <div class="ct_progress_wrap">
                    <div class="ct_progress_bar">
                      <span class="ct_progress one"></span>
                      <span class="ct_progress group"></span>
                      <span class="ct_progress empty"></span>
                    </div>

                    <div class="ct_progress_labels">
                      <span class="one">2 One-on-One</span>
                      <span class="group">3 Groups</span>
                    </div>
                  </div>
                </div>

                {/* Empty Div Section S */}
                <div className="ct_empty_job_section d-none">
                  <img src="../assets/img/start_looking_job_img.png" />
                  <div className="mt-4 text-center">
                    <h4 className="ct_fs_24 ct_darkblue_text mb-2">
                      Ahh... We’re sorrry
                    </h4>
                    <h4 className="ct_fs_24 ct_darkblue_text mb-2">
                      You have not applied to any job yet
                    </h4>
                    <p className="ct_fs_16 ct_darkblue_text mb-0">
                      Don’t worry. We are here to help you, you can start
                      matching your dream jobs.
                    </p>
                    <div className="ct_mt_30 text-center">
                      <button className="ct_yellow_btn mx-auto">
                        Start Looking for Jobs
                      </button>
                    </div>
                  </div>
                </div>
                {/* Empty Div Section E */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}


export default Growth